import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrossTabMessagingService } from './cross-tab-messaging.service';

export interface DataExchangeUpdate {
  subRequestId: number | null;
}

const DATA_EXCHANGE_CHANNEL = 'paco.dataExchange';

@Injectable({
  providedIn: 'root'
})
export class DataExchangeSyncService {

  private readonly crossTabMessaging = inject(CrossTabMessagingService);

  readonly updates$: Observable<DataExchangeUpdate> = this.crossTabMessaging.messages$<DataExchangeUpdate>(DATA_EXCHANGE_CHANNEL);

  notifyUpdated(subRequestId: number | null): void {
    this.crossTabMessaging.post<DataExchangeUpdate>(DATA_EXCHANGE_CHANNEL, { subRequestId });
  }
}
